module.exports = __webpack_public_path__ + "media/svg/se-f9da2d5f.svg";